__turbopack_context__.v({
  "additionalInfoContainer": "HeroSection-module__RYnN1W__additionalInfoContainer",
  "additionalInfoIcon": "HeroSection-module__RYnN1W__additionalInfoIcon",
  "additionalInfoItem": "HeroSection-module__RYnN1W__additionalInfoItem",
  "additionalInfoText": "HeroSection-module__RYnN1W__additionalInfoText",
  "drawCounterContainer": "HeroSection-module__RYnN1W__drawCounterContainer",
  "givingBackImage": "HeroSection-module__RYnN1W__givingBackImage",
  "gradientOverlay": "HeroSection-module__RYnN1W__gradientOverlay",
  "heroContent": "HeroSection-module__RYnN1W__heroContent",
  "heroImage": "HeroSection-module__RYnN1W__heroImage",
  "heroSection": "HeroSection-module__RYnN1W__heroSection",
  "heroText": "HeroSection-module__RYnN1W__heroText",
  "heroTitle": "HeroSection-module__RYnN1W__heroTitle",
  "heroWrapper": "HeroSection-module__RYnN1W__heroWrapper",
  "logoContainer": "HeroSection-module__RYnN1W__logoContainer",
  "titleSection": "HeroSection-module__RYnN1W__titleSection",
  "trustpilotImageContainer": "HeroSection-module__RYnN1W__trustpilotImageContainer",
});
